// extracted by mini-css-extract-plugin
module.exports = {"menuText":"#fff","menuActiveText":"#fff","subMenuActiveText":"#fff","menuBg":"#3AB488","menuHover":"#fff","subMenuBg":"#3AB488","subMenuHover":"#3AB488","sideBarWidth":"250px"};